module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reset":"Reset","confirm":"Apply"}}')
  delete Component.options._Ctor
}
